import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Headers from './Component/Header';
import Footer from './Component/Footer';
import Request from './Component/requestEstimateNew';

function FreeEstimate() {
  return (
    <div className="bg-gray-50 min-h-screen">
      <Headers />
      <Request />
      <Footer />
    </div>
  );
}

export default FreeEstimate;
